import enforcerModuleAnimation from "assets/animations/enforcerModule.json";
import sensingModuleAnimation from "assets/animations/sensingModule.json";
import streetModuleAnimation from "assets/animations/streetModule.json";
import { IPARQUE_SENSING } from "configs/links";
import { IntersectionObserverOptions } from "hooks/useIntersectionObserver";
import useLocalizedRoutes from "hooks/useLocalizedRoutes";
import useOnScreen from "hooks/useOnScreen";
import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { IParqueModule as ModuleInterface } from "./interfaces";
import IParqueModule from "./IParqueModule";
import IParqueSensing from "./IParqueSensing";
import {
  ModulesContainer,
  StyledContentContainer,
  StyledFullPageContainer,
} from "./styles";

const intersectionOptions: IntersectionObserverOptions = {
  threshold: 0.1,
  unobserveOnIntersection: true,
};

const IParqueModules: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [sensingVisible, setSensingVisible] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const isOnScreen = useOnScreen(containerRef, intersectionOptions);
  const { getLanguageRoute } = useLocalizedRoutes();

  const scrollSensingIntoView = () => {
    document.getElementById(IPARQUE_SENSING)?.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  };

  const iParqueModules: Array<ModuleInterface> = [
    {
      animationData: enforcerModuleAnimation,
      text: t("9155") /* A pensar nos agentes de fiscalização! */,
      onClick: () => navigate(getLanguageRoute("enforcer")),
      ariaLabel: t("10691") /* App para agentes de fiscalização */,
    },
    {
      animationData: streetModuleAnimation,
      text: t("9223") /* O parquímetro inteligente para a sua cidade. */,
      onClick: () => navigate(getLanguageRoute("street")),
      ariaLabel: t("10692") /* Parquímetro inteligente */,
    },
    {
      animationData: sensingModuleAnimation,
      text: t(
        "9161"
      ) /* Encontre facilmente o seu estacionamento, à distância! */,
      onClick: () => {
        if (sensingVisible) {
          scrollSensingIntoView();
          return;
        }

        setSensingVisible(true);
      },
      ariaLabel:
        t("9160") /* Gestão de disponibilidade de lugares em tempo real. */,
    },
  ];

  return (
    <>
      <article id="modules">
        <StyledFullPageContainer sensingVisible={sensingVisible}>
          <StyledContentContainer ref={containerRef}>
            <ModulesContainer>
              {iParqueModules.map((iParqueModule, index) => (
                <IParqueModule
                  key={iParqueModule.text}
                  iParqueModule={iParqueModule}
                  isSectionVisible={isOnScreen}
                  index={index}
                />
              ))}
            </ModulesContainer>
          </StyledContentContainer>
        </StyledFullPageContainer>
      </article>
      <IParqueSensing
        visible={sensingVisible}
        scrollIntoView={scrollSensingIntoView}
      />
    </>
  );
};

export default IParqueModules;
